import { Box, AuthorizeCard, Van, InStorePickup, ShipToHome, } from '@one-thd/sui-icons';
import { STATUS_CODE } from '../../constants/status';
var getPickUpTitle = function (statusCode) {
    return statusCode === STATUS_CODE.COMPLETED ? 'Picked up' : 'Ready for Pickup';
};
export var getProgressBarData = function (fulfillmentType, statusCode) {
    switch (fulfillmentType) {
        case 'ShipToHome':
            return [
                { icon: AuthorizeCard, title: 'Order Received', subtitle: '' },
                { icon: Box, title: 'Shipped', subtitle: '' },
                { icon: Van, title: 'Out For Delivery', subtitle: '' },
                { icon: ShipToHome, title: 'Delivered' },
            ];
        case 'BuyOnlinePickupInStore':
            return [
                { icon: AuthorizeCard, title: 'Order Received', subtitle: '' },
                { icon: Box, title: 'Ready for Pickup', subtitle: '' },
                { icon: Van, title: 'Picked Up', subtitle: '' },
            ];
        case 'BuyOnlineShipToStore':
            return [
                { icon: AuthorizeCard, title: 'Order Received', subtitle: '' },
                { icon: InStorePickup, title: 'Arrival at Store', subtitle: '' },
                { icon: Box, title: getPickUpTitle(statusCode), subtitle: '' },
            ];
        case 'DFS':
            return [
                { icon: AuthorizeCard, title: 'Order Received', subtitle: '' },
                { icon: Van, title: 'Out for Delivery', subtitle: '' },
                { icon: ShipToHome, title: 'Delivered', subtitle: '' },
            ];
        case 'BuyOnlineDeliverFromStore':
            return [
                { icon: AuthorizeCard, title: 'Order Received', subtitle: '' },
                { icon: Van, title: ' Out for Delivery', subtitle: '' },
                { icon: ShipToHome, title: 'Delivered', subtitle: '' },
            ];
        case 'Appliance':
            return [
                { icon: AuthorizeCard, title: 'Order Received', subtitle: '' },
                { icon: Box, title: 'Shipped', subtitle: '' },
                { icon: Van, title: 'Out for Delivery', subtitle: '' },
                { icon: ShipToHome, title: 'Delivered', subtitle: '' },
            ];
        default:
            return [];
    }
};
